import { type ReactNode } from 'react';
import * as React from 'react';
import { rgba } from 'polished';
import styled, { ThemeProvider } from 'styled-components';

import { DARK_THEME } from '@/utils/theme/themes';

const Wrapper = styled.div`
  --radius: 60px;

  cursor: pointer;
  z-index: 2;
  border-radius: var(--radius);
  overflow: hidden;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  padding: 0 calc(0.5 * var(--radius) - 0.5 * 15px);
  gap: 8px;
  color: ${({ theme }) => theme.colors.WHITE};
  background: ${({ theme }) => rgba(theme.backgroundColor, 0.88)};
  box-shadow:
    0 0 0 1px ${({ theme }) => rgba(theme.colors.BLACK, 0.06)},
    0 0 3px ${({ theme }) => rgba(theme.colors.BLACK, 0.16)},
    0 5px 10px 0 ${({ theme }) => rgba(theme.colors.BLACK, 0.06)};
  backdrop-filter: blur(10px);
  transition: background
    ${({ theme }) => `${theme.animation.DURATION} ${theme.animation.EASING}`};

  &:hover {
    background: ${({ theme }) => theme.backgroundColor};
  }
`;

interface FloatyDarkButtonProps {
  detail?: ReactNode;
  icon?: ReactNode;
  text: string;
}

export const FloatyDarkButton: React.ComponentType<FloatyDarkButtonProps> =
  React.memo(({ icon, detail, text }) => {
    return (
      <ThemeProvider theme={DARK_THEME}>
        <Wrapper>
          {icon}
          {text}
          {detail}
        </Wrapper>
      </ThemeProvider>
    );
  });
